import { z } from 'zod'

/**
 * The kinds of service a vendor can offer. Mirrors the Prisma `VendorService`
 * enum — keep the two in sync. A vendor offers a set of these; the offered set
 * gates what the vendor may configure (only `furniture` unlocks the furniture
 * library today) and what a venue may approve for that vendor.
 */
export const VENDOR_SERVICES = [
  'furniture',
  'lighting',
  'catering',
  'floral',
  'photography',
  'entertainment',
  'av',
  'planning',
  'beauty',
  'transportation',
] as const

export const vendorServiceSchema = z.enum(VENDOR_SERVICES)

export type VendorService = z.infer<typeof vendorServiceSchema>

/** Human labels for the services, for menus and tags. */
export const VENDOR_SERVICE_LABELS: Record<VendorService, string> = {
  furniture: 'Furniture',
  lighting: 'Lighting',
  catering: 'Catering',
  floral: 'Floral',
  photography: 'Photography',
  entertainment: 'Entertainment',
  av: 'AV',
  planning: 'Planning',
  beauty: 'Hair & makeup',
  transportation: 'Transportation',
}

/**
 * The services as words inside a sentence ("doesn't offer AV", "vendors for
 * flowers"). Not the labels lowercased: that gives "av".
 */
export const VENDOR_SERVICE_NOUNS: Record<VendorService, string> = {
  furniture: 'furniture',
  lighting: 'lighting',
  catering: 'catering',
  floral: 'flowers',
  photography: 'photography',
  entertainment: 'entertainment',
  av: 'AV',
  planning: 'planning',
  beauty: 'hair and makeup',
  transportation: 'transportation',
}
